var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.items,"rules":_vm.isDisabled ? [] : _vm.nameRules,"label":"Пол","disabled":_vm.isDisabled,"menu-props":{ bottom: true, offsetY: true }},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-130c2e13","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/fields/Gender.vue
// module id = q1YM
// module chunks = 0 1